import React from "react";
import VariantInfoBox from "../VariantInfoBox";
import InfoGeneTable from "../InfoGeneTable";

const RNAseqExpressionBox = ({
  RNA_GENE_ID,
  expressionData,
  metaData,
  caseId = null,
  collapsed = false,
  highlightCaseMatch = false,
}) => {
  const cleanObject = (obj) =>
    Object.entries(obj).reduce((acc, [key, val]) => {
      if (key && key !== 'undefined') acc[key] = val;
      return acc;
    }, {});
  
  const combinedData = expressionData.map((entry, index) =>
    cleanObject({
      ...entry,
      ...(metaData[index] ?? {})
    })
  );
  // console.log('combinedData',combinedData)
  const uniqueTissues = Array.from(new Set(combinedData?.map(entry => entry?.TISSUETYPE))).sort();
  // console.log('uniqueTissues',uniqueTissues)
  function showActiveCaseCardInfo(caseID, showEditView=false){
    console.log(caseID)
  }

  function updateCaseTableDataFunction(prevRowValues, columnId, newValue) {
    console.log(prevRowValues)
    console.log(columnId)
    console.log(newValue)
  }
  return (
    <VariantInfoBox
      title={
        <span>
          RNAseq Gene Expression
          <span className="fs-6 ms-3">
            ({RNA_GENE_ID || "-"})
          </span>
        </span>
      }
      min_width="40em"
      collapsed={collapsed}
    >
      <div className="d-flex flex-row gap-4">
        
        {/* <div style={{ maxHeight: '300px', overflowY: 'auto', minWidth: '650px', padding: '1rem' }}>
          <div className="d-flex text-muted">
            <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>Case</div>
            <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>normalized log2(TPM+1)</div>
            <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}> log_2(TPM+1)</div>
            <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>Individual</div>
          </div>
          
          {uniqueTissues.map(tissueType => {
            const tissueData = combinedData.filter(entry => entry.meta?.TISSUETYPE === tissueType);

            return (
              <div key={tissueType}>
                <div className="flex-grow-1 text-center" style={{ maxWidth: "650px" }}>
                  <span className="highlighted-entry">{tissueType}</span>
                </div>
          
                {tissueData
                  .sort((a, b) => b.normalized - a.normalized)
                  .map((entry, index) => {
                    const isMatch = highlightCaseMatch && caseId && entry.CASE?.trim() === caseId.trim();
                    const displayValueNormal = Math.round(entry.normalized * 100) / 100;
                    const displayValueRAW = Math.round(Math.log2(entry.raw+1) * 100) / 100;
                    const EstReadDepth = Math.round(entry.raw *150* parseInt(entry.meta?.MAPPED)/10000)/100; // ()
          
                    return (
                      <div key={`${entry.CASE}_${entry.meta?.TISSUETYPE}`} className="d-flex">
                        <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>
                          {isMatch ? <span className="highlighted-entry">{entry.CASE}</span> : entry.CASE}
                        </div>
                        <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>
                          {isMatch ? <span className="highlighted-entry">{displayValueNormal}</span> : displayValueNormal}
                        </div>
                        <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>
                          {isMatch ? <span className="highlighted-entry">{displayValueRAW}</span> : displayValueRAW}
                        </div>
                        <div className="flex-grow-1 text-center" style={{ maxWidth: "150px" }}>
                          {isMatch ? <span className="highlighted-entry">{entry.meta?.INDIVIDUAL + ' (' + entry.meta?.BIOLOGICALSEX + ')'}</span> : entry.meta?.INDIVIDUAL + ' (' + entry.meta?.BIOLOGICALSEX + ')'}
                        </div>

                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div> */}

        {/* RIGHT: Summary Stats */}
        <div style={{ maxHeight: '200px', overflowY: 'auto', minWidth: '350px', padding: '1rem' }}>
          <div className="d-flex border-bottom text-muted fw-bold">
            <div style={{ width: "120px" }} className="text-center">Tissue</div>
            <div style={{ width: "120px" }} className="text-center">Mean</div>
            <div style={{ width: "120px" }} className="text-center">Median</div>
            <div style={{ width: "120px" }} className="text-center">Std Dev</div>
            <div style={{ width: "100px" }} className="text-center">N</div>
          </div>

          {uniqueTissues.map(tissueType => {
            // Debug: Ensure combinedData has the correct filter criteria
            const tissueData = combinedData.filter(entry => entry?.TISSUETYPE === tissueType);
            // console.log(`Tissue Type: ${tissueType} - Filtered Data:`, tissueData);

            // Ensure there's data to compute summary stats
            const expressionValues = tissueData.map(entry => entry.normalized);
            if (expressionValues.length === 0) {
              return (
                <div key={tissueType} className="d-flex border-bottom py-1">
                  <div style={{ width: "120px" }} className="text-center">{tissueType}</div>
                  <div style={{ width: "120px" }} className="text-center">-</div>
                  <div style={{ width: "120px" }} className="text-center">-</div>
                  <div style={{ width: "120px" }} className="text-center">-</div>
                  <div style={{ width: "100px" }} className="text-center">0</div>
                </div>
              );
            }

            // Compute summary statistics
            const mean = expressionValues.reduce((sum, v) => sum + v, 0) / expressionValues.length;
            const sortedValues = [...expressionValues].sort((a, b) => a - b);
            const median = sortedValues.length % 2 === 0
              ? (sortedValues[sortedValues.length / 2 - 1] + sortedValues[sortedValues.length / 2]) / 2
              : sortedValues[Math.floor(sortedValues.length / 2)];
            const variance = expressionValues.length > 1
              ? expressionValues.reduce((sum, v) => sum + Math.pow(v - mean, 2), 0) / expressionValues.length
              : 0;
            const stddev = Math.sqrt(variance);

            // Return the summary stats row for this tissue
            return (
              <div key={tissueType} className="d-flex border-bottom py-1">
                <div style={{ width: "120px" }} className="text-center">{tissueType}</div>
                <div style={{ width: "120px" }} className="text-center">{Math.round(mean * 100) / 100}</div>
                <div style={{ width: "120px" }} className="text-center">{Math.round(median * 100) / 100}</div>
                <div style={{ width: "120px" }} className="text-center">{Math.round(stddev * 100) / 100}</div>
                <div style={{ width: "100px" }} className="text-center">{expressionValues.length}</div>
              </div>
            );
          })}
        </div>
        {/* LEFT: Scrollable data table */}
        <InfoGeneTable className="case-table " 
          inputData={combinedData}
          isLoadingAggNotes={true}
          visibleColumnsIds = {['TISSUETYPE','CASE_ID','normalized','log','raw','TOTALREADS','MAPPED','PCTDUPLICATION']}
          currentCaseId=""
          caseClickAction={(e, showEditView) => showActiveCaseCardInfo(e.CASE_ID, showEditView)}
          updateCaseTableData = {updateCaseTableDataFunction}
        /> 
      </div>
    </VariantInfoBox>
  );
};

export default RNAseqExpressionBox;
